import * as requestFromServer from "./basicSettingsCrud";
import { basicSettingsSlice, callTypes } from "./basicSettingsSlice";
import { dragColumnSettingsSlice } from "./dragColumnSettingsSlice";


const { actions } = basicSettingsSlice;
const dragColumnSettingsActions = dragColumnSettingsSlice.actions;

export const startCall=(actionType) => (dispatch)=>{
  dispatch(actions.startCall({ callType: callTypes[actionType] }));
}
export const endCall=(actionType) => (dispatch)=>{
  dispatch(actions.endCall({ callType: callTypes[actionType] }));
}

export const updatePOSSettings = (params, payload) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  requestFromServer
    .patchUpdateCurrency(params, payload)
    .then((res) => {
      dispatch(actions.updatePOSSettings(res.data));
    })
    .catch((error) => {
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

// Auto Apply Store Credit has its own endpoint (not part of the POS settings PATCH).
// Enabling returns a task_id for the background bulk-apply task; disabling returns a message only.
export const updateAutoApplyCredit = (payload, onSuccess) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  requestFromServer
    .postAutoApplyCredit(payload)
    .then((res) => {
      dispatch(actions.endCall({ callType: callTypes.action }));
      onSuccess && onSuccess(res.data);
    })
    .catch((error) => {
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const updateAutoApplyCreditSupplier = (payload, onSuccess) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  requestFromServer
    .postAutoApplyCreditSupplier(payload)
    .then((res) => {
      dispatch(actions.endCall({ callType: callTypes.action }));
      onSuccess && onSuccess(res.data);
    })
    .catch((error) => {
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const updateEmailSettings = (params, payload) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  requestFromServer
    .patchUpdateCurrency(params, payload)
    .then((res) => {
      dispatch(actions.updateEmailSettings(res.data));
    })
    .catch((error) => {
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const updateMSASettings = (params, payload) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  requestFromServer
    .patchUpdateCurrency(params, payload)
    .then((res) => {
      dispatch(actions.updateMSASettings(res.data));
    })
    .catch((error) => {
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const updateTaxSettings = (payload, fn) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  requestFromServer
    .patchTaxSettings(payload)
    .then((res) => {
      dispatch(actions.updateTaxSettings(res.data));
      if(fn) {
        fn();
      }
    })
    .catch((error) => {
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
}

export const updateBasicSettings = (params, payload, sideEffectHandler) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  requestFromServer
    .patchUpdateCurrency(params, payload)
    .then((res) => {
      dispatch(actions.updateBasicSettings(res.data));
      sideEffectHandler && sideEffectHandler();
    })
    .catch((error) => {
      dispatch(actions.catchError({ error, callType: callTypes.action }));
      sideEffectHandler && sideEffectHandler();
    });
};

export const updateShipmentSettings = (params, payload,cb) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.list }));
  requestFromServer
    .patchUpdateShipmentSettings(params, payload)
    .then((res) => {
      dispatch(actions.updateShipmentSettings(res.data));
      cb && cb()
    })
    .catch((error) => {
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
}
export const updateEamilNotificationsSettings = (params, payload, cb) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.list }));
  requestFromServer
    .patchUpdateEamilNotificationsSettings(params, payload)
    .then((res) => {
      dispatch(actions.updateEamilNotificationsSettings(res.data));
      if (cb) cb(res.data);
    })
    .catch((error) => {
        dispatch(actions.catchError({ error, callType: callTypes.action }));
        if (cb) cb(null, error);
    });
}

export const updateCometChatSettings = (payload, cb) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  requestFromServer
    .patchCometChatSettings(payload)
    .then((res) => {
      dispatch(actions.updateCometChatSettings(res.data));
      if (cb) cb(res.data);
    })
    .catch((error) => {
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
}

export const updateInvoiceToggleSettings = (params, payload) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  requestFromServer
    .patchUpdateToggleSettings(params, payload)
    .then((res) => {
      dispatch(actions.updateInvoiceToggleSettings(res.data));
    })
    .catch((error) => {
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const updateMessage = (type, message) => (dispatch) => {
  dispatch(actions.updateMessage({ type, message }));
};

export const getSettings = (params) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  requestFromServer
    .getSettings(params)
    .then((res) => {
      dispatch(actions.getSettings(res.data));
      const isInvoicePage = window.location.pathname.includes("/sale/invoice/");
      if (!isInvoicePage) {
        const publicKey = res.data?.entity?.["admin-panel"]?.immutable_basic?.public_key;
        if (publicKey) localStorage.setItem("tenant_public_key", publicKey);
      }
    })
    .catch((error) => {
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const getImmutableBasicSettings = (params) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  requestFromServer
    .getSettings(params)
    .then((res) => {
      dispatch(actions.getImmutableBasicSettings(res.data));
      localStorage.setItem("immutable_basic_settings", JSON.stringify(res.data.entity));
      const publicKey = res.data?.entity?.["admin-panel"]?.immutable_basic?.public_key;
      if (publicKey) localStorage.setItem("tenant_public_key", publicKey);
    })
    .catch((error) => {
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const getMSASettings = (params) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  requestFromServer
    .getSettings(params)
    .then((res) => {
      dispatch(actions.getMSASettings(res.data));
    })
    .catch((error) => {
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const getShipmentSettings = (params) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  requestFromServer
    .getSettings(params)
    .then((res) => {
      dispatch(actions.getShipmentSettings(res.data));
    })
    .catch((error) => {
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const getBasicSettings = (params) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  requestFromServer
    .getSettings(params)
    .then((res) => {
      dispatch(actions.getBasicSettings(res.data));
    })
    .catch((error) => {
      dispatch(actions.catchError({ error, callType: callTypes.action }));
      localStorage.clear();
      // window.location.href = `/auth/login`;
    });
};

export const getInvoiceSettings = (params) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  requestFromServer
    .getSettings(params)
    .then((res) => {
      dispatch(actions.updateInvoiceToggleSettings(res.data));
    })
    .catch((error) => {
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const getPOSSettings = (params) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  requestFromServer
    .getSettings(params)
    .then((res) => {
      dispatch(actions.getPOSSettings(res.data));
    })
    .catch((error) => {
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const getEmailSettings = (params) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  requestFromServer
    .getSettings(params)
    .then((res) => {
      dispatch(actions.getEmailSettings(res.data));
    })
    .catch((error) => {
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

// export const removeImage = (obj) => (dispatch) => {
//   dispatch(actions.removeImage({ obj }));
// };
// export const uploadFileToCloud = (key, file, type = "images") => (dispatch) => {
//   dispatch(actions.startCall({ callType: callTypes.action }));
//   dispatch(actions.updateUploadType({ type: type }));
//   return requestFromServer
//     .getPresignedUrl(key)
//     .then((response) => {
//       const { data } = response;
//       return requestFromServer.uploadFileToCloud({ url: data[0].url, file: file }).then((response) => {
//         if (response.status == 200) {
//           const url = response.url.split("?")[0];
//           dispatch(actions.updateUrls({ url: url, file: file, type: type }));
//         } else {
//         }
//       });
//     })
//     .catch((error) => {
//       dispatch(actions.catchError({ error, callType: callTypes.action }));
//     });
// };

export const getDragColumnListing = (params, payload, additionalOperations) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  requestFromServer
    .getDragColumnListing(params)
    .then((res) => {
      dispatch(actions.DragColumnListing({ ...res.data, ...payload }));

      // Hand the saved columns (or the caller's defaults when nothing is saved yet) to the callback —
      // it must run after they're resolved, otherwise callers like the purchase receive table get [].
      const columns = res.data?.entity?.selectedColumns?.length ? [...res.data.entity.selectedColumns] : [...(payload?.columns || [])];
      additionalOperations && additionalOperations(columns);
    })
    .catch((error) => {
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const getProductListingColumnOrder = (params, payload) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  requestFromServer
    .getProductListingColumnOrder(params, payload)
    .then((res) => {
      dispatch(actions.productListingColumnOrder({ ...res.data, ...payload }));
    })
    .catch((error) => {
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const setDragColumnListing = (params, payload) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  requestFromServer
    .patchDragColumnListing(params, payload)
    .then((res) => {
      // The PATCH response returns bulk settings (types/sub_types format) — not the
      // column entity — so we build the Redux state from what we actually sent.
      const entity = res.data?.entity?.selectedColumns ? res.data.entity : { ...payload };
      dispatch(actions.DragColumnListing({ entity }));
    })
    .catch((error) => {
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const getDragColumnListingByKey = (params, payload, additionalOperations) => (dispatch) => {
  dispatch(dragColumnSettingsActions.startCall());
  requestFromServer
    .getDragColumnListing(params)
    .then((res) => {
      const settingsKey = `${params.type}:${params.sub_type}`;
      dispatch(dragColumnSettingsActions.columnListingStored({ ...res.data, ...payload, settingsKey }));

      const columns = res.data?.entity?.selectedColumns?.length ? [...res.data.entity.selectedColumns] : [...(payload?.columns || [])];
      additionalOperations && additionalOperations(columns);
    })
    .catch((error) => {
      dispatch(dragColumnSettingsActions.catchError(error));
    });
};

export const setDragColumnListingByKey = (params, payload) => (dispatch) => {
  dispatch(dragColumnSettingsActions.startCall());
  const keyedParams = {
    ...params,
    validate_columns: params?.validate_columns ?? false,
  };
  requestFromServer
    .patchDragColumnListing(keyedParams, payload)
    .then((res) => {
      const settingsKey = `${keyedParams.type}:${keyedParams.sub_type}`;
      dispatch(dragColumnSettingsActions.columnListingStored({ ...res.data, settingsKey }));
    })
    .catch((error) => {
      dispatch(dragColumnSettingsActions.catchError(error));
    });
};

export const setProductSOsetting = (params, payload) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  requestFromServer
    .patchproductSOsetting(params, payload)
    .then((res) => {
      dispatch(actions.ProductSOsettingListing(res.data));
    })
    .catch((error) => {
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const getProductSOsetting = (params, payload) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  requestFromServer
    .getproductSOsetting(params, payload)
    .then((res) => {
      dispatch(actions.ProductSOsettingListing({ ...res.data, ...payload }));
    })
    .catch((error) => {
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};
export const getRegisterDevicesList = (params) => (dispatch) => {
  dispatch(actions.startLoading({ callType: callTypes.action }));
  requestFromServer
    .getAllRegisterDevices(params)
    .then((response) => {
      const { totalCount, entities } = response.data;
      dispatch(actions.DeviceListFetched({ totalCount, entities }));
    })
    .catch((error) => {
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const setProductListingColumnOrder = (params, payload) => (dispatch) => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  requestFromServer
    .patchProductListingColumnOrder(params, payload)
    .then((res) => {
      dispatch(actions.productListingColumnOrder(res.data));
    })
    .catch((error) => {
      dispatch(actions.catchError({ error, callType: callTypes.action }));
    });
};

export const updateShippingSettings = (obj) => (dispatch) => {
  dispatch(actions.updateShippingSettings(obj));
};

export const updateDeliveryModuleSettings = (obj) => (dispatch) => {
  dispatch(actions.updateDeliveryModuleSettings(obj));
}
